// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-431c06a8]{display:none}.wrapper[data-v-431c06a8]{align-items:center;border:1px solid var(--c-black-box-shadow);border-radius:8px;cursor:pointer;display:flex;gap:23px;padding:6px 6px 6px 12px}.wrapper__title[data-v-431c06a8]{font-size:1rem;font-weight:400;line-height:24px;padding-right:18px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
